import { render, staticRenderFns } from "./zfPackage.vue?vue&type=template&id=3d4f0aa8&scoped=true&"
import script from "./zfPackage.vue?vue&type=script&lang=js&"
export * from "./zfPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4f0aa8",
  null
  
)

export default component.exports